{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "Check-out",
      "checkInDeprecated": "Check-in (Tidak Digunakan Lagi)",
      "checkIn": "Check-in",
      "receivedLoadInspection": "Inspeksi Muatan Diterima",
      "shippedLoadVerification": "Verifikasi Muatan Dikirim",
      "appointmentsPerLoadType": "Janji Temu per Jenis Muatan",
      "assetDetails": "Detail Aset",
      "yardManagementSystem": "Sistem Manajemen Yard",
      "smartGateIntegration": "Integrasi SmartGate",
      "gateManagement": "Manajemen Gerbang",
      "idValidation": "Validasi ID",
      "appointmentCompleted": "Janji Temu Selesai"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "<strong>Nomor telepon</strong> dan <strong>perusahaan pengangkut</strong> akan dikumpulkan secara default"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "Catat detail check-in dari pengemudi untuk kedatangan terencana maupun tidak terencana.",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "Catat data check-out setelah janji temu selesai.",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "Kumpulkan info pengemudi saat mereka melakukan check-in mandiri untuk janji temu terencana. Fitur ini merupakan tambahan opsional untuk solusi Manajemen Gerbang kami.",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "Dokumentasikan kerusakan, ketidaksesuaian, atau masalah lain terkait muatan yang diterima.",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "Dokumentasikan integritas muatan dan langkah keamanan lain terkait muatan yang dikirim.",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "Catat detail khusus jenis muatan saat penjadwalan janji temu.",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "Simpan dan lacak detail trailer dan kontainer saat tiba di yard Anda.",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "Aktifkan modul YMS untuk gudang ini, serta aktifkan kolom kunjungan aset untuk aplikasi manajemen gerbang.",
      "enableTheSmartGateModuleForThisWarehouse": "Aktifkan modul SmartGate untuk gudang ini.",
      "enableTheIdValidationForThisWarehouse": "Aktifkan modul Validasi ID untuk gudang ini.",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "Aktifkan modul Manajemen Gerbang untuk gudang ini, yang mencakup check-in",
      "reviewAndManageAppointmentDataAfterCompletion": "Tinjau dan kelola data janji temu setelah selesai."
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Pelajari cara kerjanya</a> atau hubungi kami untuk <a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">meminta uji coba.</a>.",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Pelajari cara kerjanya.</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "Pengemudi akan melihat formulir ini saat melakukan check-in mandiri.",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "Semua Kolom pada formulir ini akan <strong>tersedia dan terlihat</strong> saat penjadwalan janji temu."
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "Pengemudi tidak akan melihat formulir ini saat melakukan check-in mandiri.",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "Semua Kolom pada formulir ini akan <strong>tidak tersedia</strong> saat penjadwalan janji temu.<br />Anda dapat mengaktifkan kembali formulir ini kapan saja."
    },
    "labels": {
      "updateClaimsSupport": "Perbarui Dukungan Klaim",
      "selectAClaimsSupportToUpdate": "Pilih Dukungan Klaim yang akan diperbarui",
      "damageType": "Jenis Kerusakan",
      "damageDescription": "Deskripsi Kerusakan",
      "damagePhotos": "Foto Kerusakan",
      "discrepancyType": "Jenis Ketidaksesuaian",
      "discrepancyDescription": "Deskripsi Ketidaksesuaian",
      "discrepancyPhotos": "Foto Ketidaksesuaian",
      "loadSecurityChecked": "Keamanan Muatan Diperiksa",
      "loadSecurityDescription": "Deskripsi Keamanan Muatan",
      "loadIntegrityPhotos": "Foto Integritas Muatan",
      "sealIntegrityPhotos": "Foto Integritas Segel"
    }
  }
}
